import { createContext, useState, useEffect } from "react";
import api from "../common/api";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
 
  const [loading,setLoading] = useState(true);
  const [metadata, setMetadata] = useState(null);

const applyTheme = (themeValue) => {
  if (themeValue === "default") {
    document.documentElement.removeAttribute("data-theme");
  } else {
    document.documentElement.setAttribute("data-theme", themeValue);
  }
};

const fetchTenantMeta = async () => {
  try {
    const response = await api.get("/tenant/metadata");
    return response?.data?.metadata || null;
  } catch (error) {
    console.error("Error fetching theme:", error);
    return null;
  }
};

const initMetadata = async () => {
  let data;

  try {
    data = JSON.parse(sessionStorage.getItem("metadata"));
  } catch {
    data = null;
  }

  if (!data) {
    data = await fetchTenantMeta();
    sessionStorage.setItem("metadata", JSON.stringify(data));
  }

  setMetadata(data); 

  applyTheme(data?.color || "default");
  setLoading(false);
};
  //apply theme
useEffect(() => {
  initMetadata();
}, []);

  return (
    <ThemeContext.Provider value={{  loading, metadata }}>
      {children}
    </ThemeContext.Provider>
  );
};

